import { gql } from '@apollo/client';

import { DepositorFields } from '../escrow/escrowDepositor.fragment';
import { BeneficiaryFields } from '../escrow/escrowBeneficiary.fragment';
import { EscrowInvitationFields } from '../escrow/escrowInvitation.fragment';
import { EscrowAgreementFields } from '../escrow/escrowAgreement.fragment';

import { SaasEscrowBaseFields, SaasEscrowPolicyFields } from './saasEscrow.fragment';

export * from './saasEscrow.query.generated';

export const SAAS_ESCROW = gql`
  ${SaasEscrowBaseFields}
  ${SaasEscrowPolicyFields}
  ${DepositorFields}
  ${BeneficiaryFields}
  ${EscrowInvitationFields}
  ${EscrowAgreementFields}
  query saasEscrow($saasEscrowId: ID!) {
    saasEscrow(saasEscrowId: $saasEscrowId) {
      ...SaasEscrowBaseFields
      activationNotification
      agreement {
        ...EscrowAgreementFields
      }
      agreementSettingsConfigured
      assetVersionsLimit
      currentCompanyRole
      beneficiaryConfigured
      beneficiarySharedInformation
      beneficiaryActivityNotification
      beneficiaryDisruptionNotification
      beneficiaryDisruptionNotificationGracePeriod
      depositorActivityNotification
      depositorDisruptionNotification
      depositorDisruptionNotificationGracePeriod
      depositorConfigured
      depositActivity
      depositStatus
      escrowTermination {
        id
        policy {
          accept
          reject
        }
        requesterParty
      }
      startedBy
      depositor {
        ...DepositorFields
      }
      beneficiary {
        ...BeneficiaryFields
      }
      escrowInvitation {
        ...EscrowInvitationFields
      }
      policy {
        ...SaasEscrowPolicyFields
      }
      reportsEnabled
      requiredContentTypes
      startedBy
      storageRegion
    }
  }
`;
